// Lifted directly (almost 1:1) from web-components-library to help break away from that dependency.
// Can be rebuilt/refactored if needed.
import { useEffect, useState } from 'react'

const values = {
  xs: 350,
  sm: 576,
  md: 850,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
  xxxxl: 2000,
  xxxxxl: 2500,
}

export type Breakpoint =
  'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl' | 'xxxxl' | 'xxxxxl'

export default function useBreakpoint(breakEarly = false) {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(getBreakpoint())
  const [isMobileSize, setIsMobileSize] = useState<boolean>()
  // Above is initialized as undef even though its a bool
  // Keeping it intact for backwards-compat, but a new hook should be built that addresses this and other things
  // the undefined value causes the need for useEffects
  // -ibrahim

  useEffect(() => {
    if (
      breakpoint === 'xs' ||
      breakpoint === 'sm' ||
      (breakEarly && (breakpoint === 'md' || breakpoint === 'lg'))
    ) {
      setIsMobileSize(true)
    } else {
      setIsMobileSize(false)
    }
  }, [breakpoint, breakEarly])

  useEffect(() => {
    function handleResize() {
      setBreakpoint((prev) => {
        const next = getBreakpoint()
        return prev === next ? prev : next
      })
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return { isMobileSize, breakpoint, isLoading: isMobileSize === undefined }
}

function getBreakpoint() {
  const width = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0,
  )

  if (width < values.sm) {
    return 'xs'
  } else if (width < values.md) {
    return 'sm'
  } else if (width < values.lg) {
    return 'md'
  } else if (width < values.xl) {
    return 'lg'
  } else if (width < values.xxl) {
    return 'xl'
  } else if (width < values.xxxl) {
    return 'xxl'
  } else if (width < values.xxxxl) {
    return 'xxxl'
  } else if (width < values.xxxxxl) {
    return 'xxxxl'
  }
  return 'xxxxxl'
}
